module.exports = __webpack_public_path__ + "static/img/197.c5f6c58.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phoneCloseCM/rjzz/197.jpg
// module id = M2QY
// module chunks = 0